import React from 'react'
import { useObservableImmutable } from '@core/Utils/hooks/useObservableImmutable'
import { state$ as quickbetState$ } from '@core/Areas/Quickbet/driver'
import { state$ as userAccountState$ } from '@core/State/UserAccount/userAccountDriver'
import { state$ as navigationState$ } from '@core/State/Navigation/driver'
import { useLogon } from '@core/Utils/hooks/useLogon'
import { trackKey } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import { keys } from '@classic/Foundation/Analytics/AnalyticsDataLayer'

export const useShareBetAcquisitionTracking = () => {
  const { isLoggedIn } = useLogon()

  const { betSourceShareOrigin } = useObservableImmutable(quickbetState$, ['betSourceShareOrigin'])

  React.useEffect(() => {
    if (!betSourceShareOrigin || isLoggedIn) return

    let hasTracked = false

    const loginSubscription = userAccountState$
      .map(state => state.isLoggedIn)
      .pairwise()
      .distinctUntilChanged()
      .subscribe(([prevIsLoggedIn, newIsLoggedIn]) => {
        if (!prevIsLoggedIn && newIsLoggedIn && !hasTracked) {
          trackKey(keys.shareBetLinkLogin)
          hasTracked = true
        }
      })

    const navSubscription = navigationState$.subscribe(navState => {
      const currentUrl = navState.get('currentUrl')
      if (currentUrl && currentUrl.toLowerCase().includes('signup')) {
        trackKey(keys.shareBetLinkAcquisition)
        hasTracked = true
      }
    })

    return () => {
      loginSubscription.dispose()
      navSubscription.dispose()
    }
  }, [betSourceShareOrigin, isLoggedIn])
}
